<div class="col-md-8">
  <div class="row">
    <div class="col-md-8" style="height:800px;overflow-y: auto;">
      <div class="row">
        <div *ngFor="let m of memberlist" style="padding:10px;">
          <mat-card *ngIf="m.photoUrl !== null" [ngStyle]="{'width': imagewidth + 'px', 'height': imageheight + 50 + 'px', 'font-weight': bold}" (click)="memberSelected(m)" class="mat-card-custom">
            <img mat-card-image src='{{m.photoUrl}}'>
            <mat-card-content>
              <p style="text-align:center;text-transform: uppercase;font-size:10px;">{{m.givenName}} {{m.familyName}}</p>
            </mat-card-content>
          </mat-card>
          <mat-card *ngIf="m.photoUrl === null" [ngStyle]="{'width': '200px', 'height': '250px', 'font-weight': bold}" class="mat-card-custom" (click)="memberSelected(m)">
            FOTO
            <mat-card-content>
              <p style="text-align:center;text-transform: uppercase;font-size:10px;">{{m.givenName}} {{m.familyName}}</p>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      Närvarande medlemmar<br><br>
      <div *ngFor="let m of selectedmembers">
        <div class="row">
          <div class="col-md-9">{{m.givenName}} {{m.familyName}} ({{m.id}})</div>
          <div class="col-md-3"><i class="fa fa-times" aria-hidden="true" (click)="unselectMember(m)" title="Ångra val"></i></div>
        </div>
      </div>
    </div>
  </div>
</div>